import React from 'react';
import Text from '../../text';
import { USER1ST_ENABLED } from '../../../config';
export default () => {
  if (!USER1ST_ENABLED) return null;
  return (
    <Text
      id="accessibility-btn"
      type="caption1-blinkui"
      user1stId="accessibility-btn"
      className="mt-sm-24"
      el="p"
      style={{
        cursor: 'pointer',
      }}
    >
      Open Accessibility Helper
    </Text>
  );
};
